import angular from 'angular';
import * as _ from 'lodash';

angular.module('webTools').directive('wtEnter',
    function() {
        return {
            restrict: 'A',
            link: function(scope, element, attributes) {
                element.bind("keydown keypress", function(event) {
                    if (event.which === 13) {
                        event.preventDefault();
                        scope.$apply(function() {
                            scope.$eval(attributes.wtEnter);
                        });
                    }
                });
            }
        }
    }
);

angular.module('webTools').directive('lastNode', ['$timeout', function ($timeout) {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            if (scope.$last) {
                $timeout(function () {
                    scope.$emit(attr.lastNode || 'ngRepeatFinished');
                });
            }
        }
    }
}]);

angular.module('webTools').service('Folder', ['$q', '$http',
	function($q, $http) {
	    return {
	        getPath: function(view, objectId) {
	            var promise = $q.defer();

	            $http.get('/api/documents/getpath', { params: { ObjectID: objectId, View: view } })
					.then(function (response) {
						let data = response.data;
						promise.resolve(data);
					})

	            return promise;
	        },
	        rename: function (objectId, newName) {
	            var defer = $q.defer();

	            $http.post('/api/documents/rename/', { IsFolder: true, ObjectID: objectId, ObjectType: 'fod', NewName: newName })
					.then(function (response) {
						let data = response.data;
						defer.resolve(data);
					})

	            return defer.promise;
	        }
	    }
	}
]);

angular.module('webTools').service('Utility', ['$location', '$q', '$http', '$ngRedux',
	function ($location, $q, $http, $ngRedux) {
	    return {
	        checkForIE: function () {

	            var ua = window.navigator.userAgent;

	            var msie = ua.indexOf('MSIE ');
	            if (msie > 0) {
	                // IE 10 or older => return version number
	                return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	            }

	            var trident = ua.indexOf('Trident/');
	            if (trident > 0) {
	                // IE 11 => return version number
	                var rv = ua.indexOf('rv:');
	                return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	            }

	            var edge = ua.indexOf('Edge/');
	            if (edge > 0) {
	                // IE 12 => return version number
	                return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	            }

	            // other browser
	            return false;
	        },
	        getLinkURL: function (objectID) {
						const store = $ngRedux.getState();

	            if (store.user.linkURL) {
	                return store.user.linkURL + '?ID=' + objectID + '&Dir=Objects';
	            } else {
	                var port = $location.$$port ? ':' + $location.$$port : '';
	                return $location.$$protocol + '://' + $location.$$host + port + '/?ID=' + objectID + '&Dir=Objects';
	            }
			},
	        buildWebLink: function (params) {

				let webLink = null;

				const lowerCaseParameters = _.mapKeys(params, function (v, k) { return k.toLowerCase(); });
				const preview = lowerCaseParameters['preview'] === "1";
				
				_.each(lowerCaseParameters, function (value, key) {
					if (key === 'dir') {
						webLink = {};
						switch (value.toLowerCase()) {
							case "objects":
								webLink.LinkType = 'Document';
								webLink.ID = lowerCaseParameters['id'];
								webLink.Preview = preview;
								break;
							case "searches":
								webLink.LinkType = 'Search';
								webLink.ID = lowerCaseParameters['id'];
								break;
							case "projects":
								webLink.LinkType = 'Project';
								webLink.ID = lowerCaseParameters['id'];
								break;
							default:
								break;
						}
					} else if (key === 'wfrow') {
						webLink = {};
						webLink.LinkType = 'Workflow';
						webLink.WFRow = lowerCaseParameters['wfrow'];
						webLink.WFStep = lowerCaseParameters['wfstep'];
						webLink.WFRoute = lowerCaseParameters['wfroute'];
					}
				})

				return webLink;
			},
	        getWebLinkPath: function (webLink) {

	            var defer = $q.defer();

	            $http.post('/api/app/getWebLink/', webLink)
					.then(function (response) {
						let data = response.data;
						defer.resolve(data);
					})

	            return defer.promise;
			}
	    }
	}
]);